module.exports = __webpack_public_path__ + "static/media/speaker2.67a581e7.jpg";